import { render, staticRenderFns } from "./SharedOwnershipPercentage.vue?vue&type=template&id=402a2e34"
import script from "./SharedOwnershipPercentage.vue?vue&type=script&lang=js"
export * from "./SharedOwnershipPercentage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports